import { ApolloError } from '@apollo/client'
import { useEffect, useState } from 'react'

type UseInitialLoadingProps = (
  data: object | undefined,
  loading: boolean,
  error?: ApolloError
) => boolean

/**
 * 初回ロード状態判定フック
 * データ未取得の状態も含めてロードが完了しているかどうかを判別する
 * データがない場合に404エラーを出す場合はこれを使うこと
 * @param data useQueryのdata
 * @param loading useQueryのloading
 * @param error [optional]useQueryのerror
 * @return boolean
 */
export const useInitialLoading: UseInitialLoadingProps = (
  data,
  loading,
  error
) => {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // NOTE: ロード中かデータが未取得の場合
    if (loading || (data === undefined && !error)) {
      setIsLoading(true)
    } else {
      setIsLoading(false)
    }
  }, [loading, data, error])

  return isLoading
}
